import http from './httpService';

export function getRisk(id) {
  return http.get(`/risks/${id}`);
}

export function getCourtRisk(id) {
  return http.get(`/court-risks?riskId.equals=${id}`);
}

export function getCourtRiskId(id) {
  return http.get(`/court-risks/${id}`);
}